import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.313 7.375h-2.188V10h4.293zm-3.938-.437c0-.711.574-1.313 1.313-1.313h2.624c.547 0 1.04.246 1.368.656L17.66 10H19a.9.9 0 0 1 .875.875v1.75a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875h-.902c0 .164.027.3.027.438a3.057 3.057 0 0 1-3.062 3.062 3.057 3.057 0 0 1-3.063-3.062c0-.137 0-.274.027-.438H11.07c.028.164.055.3.055.438a3.075 3.075 0 0 1-3.062 3.062A3.057 3.057 0 0 1 5 14.813c0-.137 0-.274.027-.438h-.902a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875v-1.75c0-.465.383-.875.875-.875h4.375zm0 7.875c0-.465-.273-.876-.656-1.122-.41-.246-.93-.246-1.313 0-.41.246-.656.657-.656 1.121 0 .493.246.903.656 1.149.383.246.903.246 1.313 0 .383-.246.656-.656.656-1.149m7.875 0c0-.465-.273-.876-.656-1.122-.41-.246-.93-.246-1.313 0-.41.246-.656.657-.656 1.121 0 .493.246.903.656 1.149.383.246.903.246 1.313 0 .383-.246.656-.656.656-1.149"
    }, null, -1)
  ]))]))
}
export default { render: render }